import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { User } from './../../types/user'

const initialState: User = {
	token: null,
	signInName: null,
	email: null,
	name: null,
	source: null,
}

export const UserSlice = createSlice({
	name: 'user',
	initialState,

	reducers: {
		setUser: (state, action: PayloadAction<User>) => {
			const user = action.payload

			state.token = user.token
			state.signInName = user.signInName
			state.email = user.email
			state.name = user.name
			state.source = user.source || null
		},
	},
})

export const { setUser } = UserSlice.actions

export default UserSlice.reducer
